import { Theme } from "@emotion/react";
import { Box, Drawer, styled } from "@mui/material";

type IAppbarProps = {
  darkMode?: boolean;
  theme?: Theme;
};

export const AppbarWrapper = styled(
  Box,
  {},
)<IAppbarProps>(({ theme, darkMode }) => ({
  position: "relative",
  "&.appbar-container:before": {
    content: '" "',
    gridArea: "1 / 1 / 2 / 2",
    display: "table",
  },
  "&.appbar-container": {
    borderBottom: !darkMode && "1px solid #111112",
    borderTop: !darkMode && "1px solid #111112",
    zIndex: 10,
    height: "auto",
    minHeight: "4rem",
    paddingLeft: "5%",
    paddingRight: "5%",
    display: "flex",
    position: "fixed",
    top: "0%",
    bottom: "auto",
    left: "0%",
    right: "0%",
    alignItems: "center",
    backgroundColor: darkMode ? "#111112" : "white",
    color: darkMode ? "#eaeaea" : "#111112",
    [theme.breakpoints.up("xl")]: {
      minHeight: "4.5rem",
    },
    [theme.breakpoints.between("lg", "xl")]: {
      minHeight: "4rem",
    },
    [theme.breakpoints.between("md", "lg")]: {
      minHeight: "3.783rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      minHeight: "3.649rem",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      minHeight: "3.887rem",
    },
    "@media (min-width: 375px) and (max-width: 425px)": {
      minHeight: "3.88rem",
    },
    "@media (min-width: 320px) and (max-width: 375px)": {
      minHeight: "3.79rem",
    },
    "@media (min-width: 0px) and (max-width: 320px)": {
      minHeight: "3.667rem",
    },
    ".appbar": {
      gridColumnGap: "0rem",
      gridRowGap: "0rem",
      gridTemplateRows: "auto",
      gridTemplateColumns: ".25fr 1fr .25fr",
      gridAutoColumns: "1fr",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      maxWidth: "80rem",
      height: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      display: "grid",
      position: "relative",
      [theme.breakpoints.up("xl")]: {
        maxWidth: "90rem",
      },
      ".logo-div": {
        ".logo": {
          width: "5.5rem",
          height: "1.241rem",
          cursor: "pointer",
          display: "block",
          [theme.breakpoints.up("xl")]: {
            width: "6.188rem",
            height: "1.396rem",
          },
          [theme.breakpoints.between("lg", "xl")]: {
            width: "5.488rem",
            height: "1.238rem",
          },
          [theme.breakpoints.only("lg")]: {
            width: "5.319rem",
            height: "1.203rem",
          },
          [theme.breakpoints.between("md", "lg")]: {
            width: "5.202rem",
            height: "1.174rem",
          },
          [theme.breakpoints.between("sm", "md")]: {
            width: "5.019rem",
            height: "1.133rem",
          },
          [theme.breakpoints.between("xs", "sm")]: {
            width: "5.344rem",
            height: "1.206rem",
          },
          "@media (min-width: 375px) and (max-width: 425px)": {
            width: "5.34rem",
            height: "1.19rem",
          },
          "@media (min-width: 320px) and (max-width: 375px)": {
            width: "5.2rem",
            height: "1.174rem",
          },
          "@media (min-width: 0px) and (max-width: 320px)": {
            width: "5.042rem",
            height: "1.138rem",
          },
        },
      },
      ".actions": {
        gridColumnGap: ".25rem",
        gridRowGap: ".25rem",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        position: "static",
        [theme.breakpoints.down("md")]: {
          justifyContent: "end",
        },
        button: {
          letterSpacing: "-.015em",
          cursor: "pointer",
          fontVariationSettings: '"wght" 450',
          fontSize: "1rem",
          lineHeight: "1.5",
          textTransform: "Capitalize",
          display: "inline-block",
          padding: ".125rem .5rem",
          [theme.breakpoints.between("md", "lg")]: {
            fontSize: ".97rem",
          },
          [theme.breakpoints.between("lg", "xl")]: {
            fontSize: ".97rem",
          },
          [theme.breakpoints.up("xl")]: {
            fontSize: "1.13rem",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,.2)",
          },
        },
      },
      ".menu": {
        width: "99%",
        display: "flex",
        justifyContent: "end",
        "@media (min-width: 0px) and (max-width: 320px)": {
          width: "97%",
        },
      },
      ".menu-cross": {
        width: "110%",
        display: "flex",
        justifyContent: "end",
        "@media (min-width: 425px) and (max-width: 768px)": {
          width: "104%",
        },
        "@media (min-width: 375px) and (max-width: 425px)": {
          width: "110%",
        },
        svg: {
          height: "1.7rem",
          width: "1.8rem",
          "@media (min-width: 425px) and (max-width: 768px)": {
            height: "1.6rem",
            width: "1.7rem",
          },
          "@media (min-width: 375px) and (max-width: 425px)": {
            height: "1.7rem",
            width: "1.8rem",
          },
          "@media (min-width: 0px) and (max-width: 320px)": {
            height: "1.6rem",
            width: "1.7rem",
          },
        },
      },
    },
  },
}));

export const DrawerWrapper = styled(
  Drawer,
  {},
)<IAppbarProps>(({ theme, darkMode }) => ({
  "&.MuiDrawer-root": {
    marginTop: "3.5rem",
    overflowY: "scroll",
    padding: 0,
    ".MuiBackdrop-root": {
      marginTop: "3.5rem",
    },
    ".MuiDrawer-paper": {
      position: "fixed",
      marginTop: "3.649rem",
      width: "100%",
      boxShadow: "none",
    },
    ".MuiList-padding": {
      background: darkMode ? "#111112" : "#eaeaea",
      color: darkMode ? "#eaeaea" : "#111112",
      padding: "1rem calc(5% - .125rem) 2rem",
      overflowY: "scroll",
      "@media (min-width: 425px) and (max-width: 768px)": {
        padding: ".95rem calc(5% - .125rem) 2rem",
      },
      "@media (min-width: 375px) and (max-width: 425px)": {
        padding: "1.2rem calc(5% - .125rem) 2rem",
      },
      "@media (min-width: 325px) and (max-width: 375px)": {
        padding: "1.1rem calc(5% - .125rem) 2rem",
      },
      li: {
        padding: ".125rem .5rem",
        marginBottom: ".5rem",
      },
      [`${theme.breakpoints.down("sm")} and (orientation: landscape)`]: {
        minHeight: "305px",
      },
    },
    ".drawer-buttons": {
      margin: 0,
      span: {
        "@media (min-width: 375px) and (max-width: 425px)": {
          fontSize: "1.07rem",
        },
        "@media (min-width: 320px) and (max-width: 375px)": {
          fontSize: "1.04rem",
        },
        "@media (max-width: 320px)": {
          fontSize: "1.001rem",
        },
      },
    },
  },
}));
